import config from '../../../constants/config';

// Bing Tracking Pixel
if (config.VERIZON_TRACKING_PIXEL) {
  /* eslint-disable */
  (function (w, d, t, r, u) {
    w[u] = w[u] || [];
    w[u].push({ projectId: '10000', properties: { pixelId: config.VERIZON_TRACKING_PIXEL } });
    var s = d.createElement(t);
    s.src = r;
    s.defer = 1;
    s.onload = s.onreadystatechange = function () {
      var y,
        rs = this.readyState,
        c = w[u];
      if (rs && rs != 'complete' && rs != 'loaded') {
        return;
      }
      try {
        y = YAHOO.ywa.I13N.fireBeacon;
        w[u] = [];
        w[u].push = function (p) {
          y([p]);
        };
        y(c);
      } catch (e) {}
    };
    var scr = d.getElementsByTagName(t)[0],
      par = scr.parentNode;
    par.insertBefore(s, scr);
  })(window, document, 'script', 'https://s.yimg.com/wi/ytc.js', 'dotq');
  window.dotq = window.dotq || [];
  /* eslint-enable */
}

